import { FormattedMessage } from "react-intl";
import { EcgMeasurements } from "../../../../api/index.defs";
import NoDataIndicator from "../../../Shared/NoDataIndicator/NoDataIndicator";
import MetaCard from "../MetaCard/MetaCard";

type MeasurementsProps = {
  measurements?: EcgMeasurements;
  compare?: boolean;
};

const Measurements = ({ measurements, compare }: MeasurementsProps) => {
  return (
    <MetaCard compare={compare}>
      <div className="font-md">
        <p className="prim-color-dark font-weight-bold mb-0">
          {measurements?.isUnconfirmed ? (
            <FormattedMessage
              id="ECG_DETAILS.AUTOMATED_MEASUREMENTS"
              defaultMessage="Automated Measurements"
            />
          ) : (
            <FormattedMessage
              id="ECG_DETAILS.MEASUREMENTS"
              defaultMessage="Measurements"
            />
          )}
        </p>
        {!measurements ? null : (
          <table className="w-100 mt-2">
            <tbody>
              <tr>
                <td className="pb-1">
                  <FormattedMessage
                    id="ECG_DETAILS.MEASUREMENTS.AVG_HEART_RATE"
                    defaultMessage="Avg. Heart Rate"
                  />
                  :&nbsp;
                  {!measurements.rate || measurements.rate === "0" ? (
                    <NoDataIndicator />
                  ) : (
                    measurements.rate
                  )}
                  <span className="muted-color">
                    &nbsp;
                    <FormattedMessage
                      id="ECG_DETAILS.MEASUREMENTS.BPM"
                      defaultMessage="BPM"
                    />
                  </span>
                </td>
                <td></td>
              </tr>
              <tr>
                <td className="pb-1">
                  <FormattedMessage
                    id="ECG_DETAILS.MEASUREMENTS.PR"
                    defaultMessage="PR"
                  />
                  :&nbsp;
                  {!measurements.pr || measurements.pr === "0" ? (
                    <NoDataIndicator />
                  ) : (
                    measurements.pr
                  )}
                  <Unit isMs={measurements.isMs} />
                </td>
                <td className="pb-1">
                  <FormattedMessage
                    id="ECG_DETAILS.MEASUREMENTS.QRS"
                    defaultMessage="QRS"
                  />
                  :&nbsp;
                  {!measurements.qrs || measurements.qrs === "0" ? (
                    <NoDataIndicator />
                  ) : (
                    measurements.qrs
                  )}
                  <Unit isMs={measurements.isMs} />
                </td>
              </tr>
              <tr>
                <td className="pb-1">
                  <FormattedMessage
                    id="ECG_DETAILS.MEASUREMENTS.QT"
                    defaultMessage="QT"
                  />
                  :&nbsp;
                  {!measurements.qt || measurements.qt === "0" ? (
                    <NoDataIndicator />
                  ) : (
                    measurements.qt
                  )}
                  <Unit isMs={measurements.isMs} />
                </td>
                <td className="pb-1">
                  <FormattedMessage
                    id={`${
                      measurements.qtcb
                        ? "ECG_DETAILS.MEASUREMENTS.QTCB"
                        : "ECG_DETAILS.MEASUREMENTS.QTCF"
                    }`}
                    defaultMessage={`${measurements.qtcb ? "QTcB" : "QTcF"}`}
                  />
                  :&nbsp;
                  {measurements.qtcb ? (
                    measurements.qtcb === "0" ? (
                      <NoDataIndicator />
                    ) : (
                      measurements.qtcb
                    )
                  ) : !measurements.qtcf || measurements.qtcf === "0" ? (
                    <NoDataIndicator />
                  ) : (
                    measurements.qtcf
                  )}
                  <Unit isMs={measurements.isMs} />
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </MetaCard>
  );
};

export default Measurements;

const Unit = ({ isMs }: { isMs?: boolean }) => {
  return (
    <span className="muted-color">
      &nbsp;
      {isMs ? (
        <FormattedMessage id="UNITS.MSEC" defaultMessage="ms" />
      ) : (
        <FormattedMessage id="UNITS.SEC" defaultMessage="sec" />
      )}
    </span>
  );
};
